<template>
  <!-- 弹窗 -->
  <a-modal
    :cancel-text="a_modal.cancelText"
    :ok-text="a_modal.okText"
    :title="a_modal.title"
    v-model:open="a_modal.visible"
    @ok="a_modal.handleOk"
  >
    {{ a_modal.content }}
  </a-modal>

  <!-- loading遮罩 -->
  <div v-if="loading" class="loading">
    <a-spin :spinning="loading" :indicator="customIndicator" size="large" tip="正在获取定位，请耐心等待..."></a-spin>
  </div>

  <div class="location">
    <div class="header" @click="backToHome">
      <LeftOutlined />
      返回
    </div>

    <div class="amap">
      <a-tabs>
        <a-tab-pane>
          <template #tab>
            <div>
              <CarTwoTone style="font-size: 18px;" />
              <span style="font-size: 14px;">更新定位</span>
            </div>
          </template>
          <div id="map" style="width: 100%; height: 400px; z-index: 0"></div>
          <div v-if="post_result" class="btn">
            <a-button type="primary" @click="resubmit">重新提交</a-button>
          </div>
          <div v-if="! post_result" class="btn">
            <a-input v-model:value="lnglat" placeholder="坐标" />
            <a-button type="primary" @click="submit">提交</a-button>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script setup>
import { message } from 'ant-design-vue'
import axios from 'axios'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AMapLoader from '@amap/amap-jsapi-loader'
import { CarTwoTone, LeftOutlined } from '@ant-design/icons-vue'

const route = useRoute()
const router = useRouter()
const uuid = ref(null)
const loading = ref(false)
const lnglat = ref(null)
const post_result = ref(false)
const a_modal = ref({
  cancelText: '取消', 
  content: '', 
  handleOk: null, 
  okText: '确定', 
  title: '', 
  visible: false, 
})
const backToHome = () => {
  router.push(`/${uuid.value}`)
}
const postPosition = (params) => {
  return axios.post('https://api.gdpinganxing.com/api/cs/location', params)
}
const resubmit = () => {
  post_result.value = false
}
const submit = async() => {
  const params = {
    uuid: uuid.value,
    location: lnglat.value,
    address: ''
  }
  const response = await postPosition(params)
  if (response.data.code !== 200) {
    message.success('位置上报失败！')
    post_result.value = false
    return
  }
  a_modal.value.title = 'Tips:'
  a_modal.value.content = '定位上报成功，感谢您对我们工作的支持！'
  a_modal.value.visible = true
  a_modal.value.handleOk = () => {
    a_modal.value.visible = false
  }
  post_result.value = true
}

onMounted(async() => {
  uuid.value = route.params.id

  // 高德JSCode
  window._AMapSecurityConfig = { securityJsCode: 'b4d30877b0db490edc2eb8ffcc6eea9f' }

  // 获取定位
  AMapLoader.reset()
  AMapLoader.load({
    key: '7cf08afbf0ae12a1b8ed9d6826bdda83',
    version: '2.0',
    plugins: ['AMap.Geolocation']
  }).then((AMap) => {
    // 点击地图事件
    const map = new AMap.Map('map', {            // 创建地图实例
      city: '广州市'
    })
    let marker = null
    AMap.plugin('AMap.Geolocation', () => {
      const geolocation = new AMap.Geolocation({
        buttonPosition: 'RB',                    // 定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(10, 20),    // 定位按钮距离对应角落的距离
        enableHighAccuracy: true,                // 是否使用高精度定位，默认:true
        showButton: false,                       // 显示定位按钮
        timeout: 10000,                          // 超过10秒后停止定位，默认：5s
        panToLocation: false,                    // 成功后位移
        zoomToAccuracy: true,                    // 定位成功后是否自动调整地图视野到相应级别
      })
      geolocation.getCurrentPosition(async(status, result) => {
        loading.value = false
        if(status === 'complete') {
          if (result.code === 0 && result.info === 'SUCCESS') {
            // 定位成功
            const { position } = result
            map.setCenter(position)
            marker = new AMap.Marker({
              position: position,
              map: map,
            })
            map.setZoom(16)
            lnglat.value = [result.position.lng, result.position.lat]
            submit()
          }
        } else if(status == 'error') {
          a_modal.value.title = 'Tips:'
          a_modal.value.content = '获取定位失败: 您可以手动更新位置信息'
          a_modal.value.visible = true
          a_modal.value.handleOk = () => {
            a_modal.value.visible = false
          }
        }
      })
    })
    
    map.on('click', (e) => {
      // 移除标记
      if(marker) {
        map.remove(marker)
      }
      // 添加标记
      marker = new AMap.Marker({
        position: [e.lnglat.getLng(), e.lnglat.getLat()],
        map: map
      })
      // 更新坐标
      lnglat.value = [e.lnglat.getLng(), e.lnglat.getLat()]
    })
  }).catch(error => {
    a_modal.value.title = '错误'
    a_modal.value.content = `地图加载失败：请联系技师/客服 ${error}`
    a_modal.value.visible = true
    a_modal.value.handleOk = () => {
      a_modal.value.visible = false
    }
  })
})
</script>

<style scoped>
.loading {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 9;
}
.amap {
  margin-top: 58px;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  z-index: 1;
}
.btn {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
.btn > input {
  margin-right: 16px;
}
</style>